// @ts-nocheck
/* eslint-env commonjs */
/* global process */
import { createStore, applyMiddleware, Store } from "redux";
import thunk from "redux-thunk";
import Immutable from "immutable";
import createLogger from "redux-logger";
import ActionTypes from "../constants/actions";
import reducer from "../reducers";

export function createRedux(initialState?: Record<string, unknown>): Store {
  const middleware: any[] = [thunk];

  if (process.env.NODE_ENV !== "production") {
    middleware.push(
      createLogger({
        collapsed: true,
        predicate: (getState: any, action: any) => !(action.type === ActionTypes.ROUTER_STATE_CHANGE)
      })
    );
  }

  const finalCreateStore = applyMiddleware(...middleware)(createStore);
  const store = finalCreateStore(reducer, initialState);

  if (import.meta.hot) {
    const nextReducer = reducer;

    import.meta.hot.accept("../reducers", () => {
      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

interface RecordWithId {
  _id: string;
}

type ImmutableSet<T> = Immutable.Set<T>;
type RecordFactory<T> = new (data: T) => T & Immutable.Record<T>;

export function mergeArraytoSet<T extends RecordWithId>(
  payload: T[] = [],
  state: ImmutableSet<T> = Immutable.Set(),
  record: RecordFactory<T>
): ImmutableSet<T> {
  let newState = state;
  payload.forEach(item => {
    const exists = newState.find((v: T) => item._id === v._id);
    if (!exists) {
      newState = newState.add(new record(item));
    }
  });
  return newState;
}

export function addToSet<T extends RecordWithId>(
  payload: T,
  state: ImmutableSet<T> = Immutable.Set(),
  record: RecordFactory<T>
): ImmutableSet<T> {
  const exists = state.find((v: T) => payload._id === v._id);
  if (!exists) {
    return state.add(new record(payload));
  }
  return state;
}

export function updateSet<T extends RecordWithId>(
  payload: T,
  state: ImmutableSet<T> = Immutable.Set(),
  record: RecordFactory<T>
): ImmutableSet<T> {
  const exists = state.find((v: T) => payload._id === v._id);
  if (exists) {
    let newState = state.delete(exists);
    return newState.add(new record(payload));
  }
  return state;
}

export function removeFromSet<T extends RecordWithId>(
  payload: T,
  state: ImmutableSet<T> = Immutable.Set()
): ImmutableSet<T> {
  const exists = state.find((v: T) => payload._id === v._id);
  if (exists) {
    return state.delete(exists);
  }
  return state;
}
